import _slicedToArray from "/home/denis/workspace/smartheat/pump-services/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _styled from "styled-components";
import React, { useMemo } from "react";
import { useRegistersSubscription } from "../../DeviceData/useRegistersSubscription";
import { useSetRegisterMutation } from "../../DeviceData/useSetRegisterMutation";
import { useRegisterConfigQuery } from "../../DeviceData/useRegisterConfigQuery";
import { RegisterControl } from "../../controls/RegisterControl";

var Container = _styled.div.withConfig({
  displayName: "ParamsScreen__Container",
  componentId: "sc-1gd4yt7-0"
})(["flex:1;display:flex;flex-direction:column;height:0;"]);

var Description = _styled.div.withConfig({
  displayName: "ParamsScreen__Description",
  componentId: "sc-1gd4yt7-1"
})(["text-align:center;margin-top:60px;font-size:24px;"]);

var ParamsContainer = _styled.div.withConfig({
  displayName: "ParamsScreen__ParamsContainer",
  componentId: "sc-1gd4yt7-2"
})(["margin-top:40px;overflow-y:auto;background:linear-gradient(white 30%,rgba(255,255,255,0)),linear-gradient(rgba(255,255,255,0),white 70%) 0 100%,radial-gradient(50% 0,farthest-side,rgba(0,0,0,0.2),rgba(0,0,0,0)),radial-gradient(50% 100%,farthest-side,rgba(0,0,0,0.2),rgba(0,0,0,0)) 0 100%;background:linear-gradient(white 30%,rgba(255,255,255,0)),linear-gradient(rgba(255,255,255,0),white 70%) 0 100%,radial-gradient(farthest-side at 50% 0,rgba(0,0,0,0.2),rgba(0,0,0,0)),radial-gradient(farthest-side at 50% 100%,rgba(0,0,0,0.2),rgba(0,0,0,0)) 0 100%;background-repeat:no-repeat;background-color:white;background-size:100% 40px,100% 40px,100% 14px,100% 14px;background-attachment:local,local,scroll,scroll;"]);

export function ParamsScreen(_ref) {
  var serviceMenu = _ref.serviceMenu,
      screen = _ref.screen;
  var screenIdx = screen.idx || 0;
  var sectionConfig = serviceMenu.screens[screenIdx];
  var allRegisters = useMemo(function () {
    return sectionConfig ? sectionConfig.registers.map(function (_ref2) {
      var register = _ref2.register;
      return register;
    }) : [];
  }, [sectionConfig]);

  var _useRegistersSubscrip = useRegistersSubscription(allRegisters),
      registersData = _useRegistersSubscrip.registersData;

  var registersConfig = useRegisterConfigQuery(allRegisters);

  var _useSetRegisterMutati = useSetRegisterMutation(),
      _useSetRegisterMutati2 = _slicedToArray(_useSetRegisterMutati, 1),
      setRegister = _useSetRegisterMutati2[0];

  var registers = useMemo(function () {
    return registersConfig ? allRegisters.map(function (regName) {
      return registersConfig[regName];
    }).filter(function (conf) {
      return !!conf;
    }) : [];
  }, [allRegisters, registersConfig]);

  if (!sectionConfig || !registersConfig) {
    return null;
  }

  return /*#__PURE__*/React.createElement(Container, null, /*#__PURE__*/React.createElement(Description, null, sectionConfig.title), /*#__PURE__*/React.createElement(ParamsContainer, null, registers.map(function (regConfig) {
    return /*#__PURE__*/React.createElement(RegisterControl, {
      key: regConfig.id,
      regConfig: regConfig,
      value: registersData[regConfig.id],
      setRegister: setRegister
    });
  })));
}